import { App } from "vue";

const lang = "da";

export default {
  install: (app: App) => {
    const translateFunction: (key: string) => string = (key: string) => {
      const languageConfig = config[lang];
      return languageConfig[key];
    };
    app.config.globalProperties.$translate = translateFunction;

    app.provide("$translate", translateFunction);
  },
};

const config: { [key: string]: { [key: string]: string } } = {
  da: {
    TextResources_Role: "Rolle",
    TextResources_Roles: "Roller",
    TextResources_Profile: "Profil",
    TextResources_Profiles: "Profiler",
    TextResources_DeleteProfile: "Slet Profil",
    TextResources_ProfileName: "Profilnavn",
    TextResources_Description: "Beskrivelse",
    TextResources_SaveChange: "Gem ændringer",
    TextResources_Add: "Tilføj",
    TextResources_CreateProfile: "Opret profil",
    TextResources_FoundNumberProfile: "Der blev fundet ",
    TextResources_Create: "Opret",
    TextResources_EmptyProfile: "Ingen profiler",
    TextResources_EmptyProfileDescription:
      "Ingen profiler knyttet til denne applikation er blevet oprettet endnu",
    TextResources_ProfileNotHaveRoles: "Denne profil har ingen tildelte roller",
    TextResources_EmptyRole: "Ingen roller",
    TextResources_EmptyRoleDescription:
      "Der er ikke nogle roller tilknyttet denne bruger endnu",
    TextResources_CreatedProfile: "Profil oprettet",
    TextResources_CreatedProfileDescription: "Den har fået ID",
    TextResources_UpdatedProfile: "Profil ændret",
    TextResources_UpdatedProfileDescription: "Dine ændringer er blevet gemt",
    TextResources_DeletedProfile: "Profil slettet",
    TextResources_DeletedProfileDescription: "Profilen er blevet slettet",
    TextResources_SaveChangeWarningQuestion:
      "Du har foretaget ændringer der ikke er gemt, vil du stadig gå tilbage?",
    TextResources_SaveChangeWarningAnswerConfirm: "Ja, gå tilbage",
    TextResources_SaveChangeWarningAnswerCancel: "Afbryd",

    TextResources_DeleteProfileWarningQuestion:
      "Er du sikker på at du vil slette rollen? Denne handling kan ikke fortrydes",
    TextResources_DeleteProfileWarningnswerConfirm: "Ja, slet",
    TextResources_DeleteProfileWarningAnswerCancel: "Afbryd",

    TextResources_LevelOfUse: "Anvendelsesniveau",
    TextResources_LevelOfUse_Organization: "Organisation",
    TextResources_LevelOfUse_User: "Bruger",

    TextResources_EnrollmentStatus: "To-faktor",
    TextResources_EnrollmentStatus_ENROLLED: "Indrulleret",
    TextResources_EnrollmentStatus_OMITTED: "Undtaget",
    TextResources_EnrollmentStatus_NOT_ENROLLED: "Ikke indrulleret",
    TextResources_ResetTwoFactor: "Reset to-faktor",
    TextResources_ResetTwoFactorSucceeded: "To-faktor nulstillet",
    TextResources_ResetTwoFactorSucceededDescription:
      "Brugerens to-faktor-registrering er nulstillet. Brugeren skal konfigurere to-faktor igen ved næste login, hvor det kræves.",
    TextResources_ResetTwoFactorFailed:
      "Nulstilling af to-faktor ikke fuldført",
    TextResources_ResetTwoFactorFailedDescription:
      "Nulstillingen blev ikke fuldført. Brugeren er muligvis ikke længere indrulleret, eller tjenesten er midlertidigt utilgængelig. Opdatér siden for at se den aktuelle status. Kontakt support, hvis problemet fortsætter.",
    TextResources_ResetTwoFactorRequestFailed:
      "Nulstillingen kunne ikke bekræftes. Kontrollér din forbindelse og dine rettigheder, opdatér siden, og prøv igen. Kontakt support, hvis problemet fortsætter.",
    TextResources_ResetTwoFactorRefreshFailed:
      "To-faktor nulstillet – status kunne ikke opdateres",
    TextResources_ResetTwoFactorRefreshFailedDescription:
      "Nulstillingen lykkedes, men den seneste status kunne ikke hentes. Opdatér siden for at se den aktuelle status. Du behøver ikke nulstille igen.",
  },
};
